import { Avatar, Box, Chip, Typography } from "@mui/material"
import homepage from "../../assets/images/homepage.png"
import { useNavigate } from "react-router-dom"
import feeditem from "../../assets/images/feeditem.png"
import seed from "../../assets/images/seed.avif"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import Icn from "../UI/SharieIcn/SharieIcn"
import ShariLogo from "../../assets/images/shariehandslogo.png"
import useDeviceType from "../hooks/Utils/useDeviceType"
import shariedemo from "../../assets/images/sharie_demo.mp4"
import shariead from "../../assets/images/sharie_ad.mp4"
import DescriptionIcon from "@mui/icons-material/Description"
import { useEffect } from "react"
import { useApiService } from "../hooks/Api/useApiService"
import LanguageToggle from "../UI/LanguageToggle"

const LoadingPage = () => {
  const navigate = useNavigate()
  const t = useTranslationSharie()
  const deviceType = useDeviceType()
  const { getData } = useApiService()

  useEffect(() => {
    getData("test")
  }, [])

  const goToSignUp = () => {
    navigate("/signup")
  }
  const goToLogin = () => {
    navigate("/login")
  }
  const goToHomepage = () => {
    localStorage.removeItem("user")
    localStorage.setItem("guest", "true")
    navigate("/home")
  }
  const handleClickCV = () => {
    navigate("/kobiCV")
  }
  return (
    <T>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
      >
        {/* Header Row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "1200px",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* Logo + Navigation */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Icn label='logo' avatar={<Avatar src={ShariLogo} alt='Icon' />} />
            <LanguageToggle />
            {/* <Typography variant='h6' gutterBottom sx={{ color: "#1976d2" }}>
              Sharie®
            </Typography> */}
            <Icn
              onClick={handleClickCV}
              tooltip={"Who am I?"}
              label='kobicv'
              icon={<DescriptionIcon color='secondary' />}
            />

            {/* <Typography
              variant='h6'
              gutterBottom
              onClick={goToHomepage}
              sx={{
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Discover
            </Typography> */}

            <Typography
              variant='h6'
              gutterBottom
              onClick={goToLogin}
              sx={{
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Connect
            </Typography>
          </Box>

          {/* Join Now */}
          <Chip
            label={t("Join Now")}
            color='primary'
            onClick={goToSignUp}
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              p: 0.5,
              cursor: "pointer",
              maxWidth: "150px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        </Box>

        {/* Main Heading */}
        <Box sx={{ mt: 5, textAlign: "center" }}>
          <Typography variant='h4' fontWeight='bold' gutterBottom>
            Skills. Shared. Elevated.
          </Typography>
          <Typography variant='h4' fontWeight='bold' gutterBottom sx={{ color: "lightgray" }}>
            Share talent. Unlock growth.
          </Typography>
        </Box>

        {/* Main Image */}
        <Box
          sx={{
            mt: 5,
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <video
            src={shariedemo}
            alt='app home page demo'
            style={{ width: "40%", borderRadius: "8px" }}
            controls // <---- add this!
          />
          <video
            src={shariead}
            alt='app home page ad'
            style={{ width: "40%", borderRadius: "8px" }}
            controls // <---- add this!
          />
        </Box>
        {/* Collaborators Section */}
        <Box
          sx={{
            mt: { xs: 10, md: 20 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 4,
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant='h4' gutterBottom>
              Find collaborators.
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              Discover skilled people and learn
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              what matches your interests.
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              mt: { xs: 4, md: 0 },
            }}
          >
            <img
              src={homepage}
              alt='app home page'
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Box>
        </Box>

        {/* Showcase Section */}
        <Box
          sx={{
            mt: { xs: 10, md: 20 },
            display: "flex",
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "center",
            gap: 4,
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              mt: { xs: 4, md: 0 },
            }}
          >
            <img
              src={feeditem}
              alt='app home page'
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant='h4' gutterBottom>
              Showcase talents.
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              Share your unique skills and
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              portfolio to attract new
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              opportunities.
            </Typography>
          </Box>
        </Box>

        {/* Grow Together Section */}
        <Box
          sx={{
            mt: { xs: 10, md: 20 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 4,
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant='h4' gutterBottom>
              Grow together.
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              Build a supportive network that
            </Typography>
            <Typography variant='h5' gutterBottom sx={{ color: "gray" }}>
              helps you and others thrive.
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              mt: { xs: 4, md: 0 },
            }}
          >
            <img src={seed} alt='app home page' style={{ width: "100%", borderRadius: "8px" }} />
          </Box>
        </Box>
      </Box>
    </T>
  )
}
export default LoadingPage
